import { render, staticRenderFns } from "./ExpenseGroup.vue?vue&type=template&id=f9a00d46&"
import script from "./ExpenseGroup.vue?vue&type=script&lang=js&"
export * from "./ExpenseGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports